import React from "react";
import { Link } from "react-router-dom";
import "../service.css";

export const Onboard = () => {
  return (
    <div>
      <div className="tj-inner-banner">
        <div className="container">
          <h2>Safety Onboard</h2>
        </div>
      </div>

      <div className="tj-breadcrumb">
        <div className="container">
          <ul className="breadcrumb-list">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li className="active">Safety Onboard</li>
          </ul>
        </div>
      </div>

      <div className="container">
        <div style={{ padding: "30px", display: "flex" }}></div>

        <h1 className="farex-h1" style={{ textAlign: "center" }}>
          Safety Onboard
        </h1>

        <div id="section-43566" style={{ clear: "both" }}>
          <div
            className="basic-page-paragraph-container"
            style={{ clear: "both" }}
          >
            <div>
              {/*      <div className="image-text-horizontal-floated-right">
                <figure>
                  <div className="image-with-copyright-info--container">
                    <img
                      src="https://cdn-cf.cms.Farex.com/drupal-assets/styles/20px/s3/2024-02/india_seat_belt_2.png"
                      className="image-text-horizontal-floated-image"
                      alt="On-board safety at Farex"
                      height="258px"
                      width="360px"
                      data-lazyload="https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_horizontal/s3/2024-02/india_seat_belt_2.png 360w, https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_horizontal_2x/s3/2024-02/india_seat_belt_2.png 720w"
                      sizes="(min-width: 600px) 360px, 100vw"
                    />

                    <p className="image-with-copyright-info--text">© Farx</p>
                  </div>
                </figure>
              </div> */}

              <div className="farex-text image-text-horizontal-text">
                <h2>Travel safely throughout India with Farex</h2>
                <p>
                  car are among the safest modes of transport on the road. The
                  increasing investment in India&apos;s highways allows more
                  routes and a safer, more comfortable journey. As getting you
                  to your destination safely is our main priority, our modern
                  green car meet the highest safety standards and our Farex
                  drivers are trained using the latest methods. All semi-sleeper
                  car have seat belts installed on them, and we strongly
                  advise all passengers to use them all the time while seated.
                  Additionally, our car are equipped with GPS live update
                  tracking system, so that you can travel with more piece of
                  mind.              
                </p>
              </div>
            </div>
          </div>
        </div>

        <div id="section-43569" style={{ clear: "both" }}>
          <div
            className="basic-page-paragraph-container"
            style={{ clear: "both" }}
          >
            <div className="farex-grid image-text-horizontal-left">
              {/*   <div className="farex-col-12 farex-col-6-md image-text-horizontal-image-wrapper-left">
                <figure>
                  <div className="image-with-copyright-info--container">
                    <img
                      src="https://cdn-cf.cms.Farex.com/drupal-assets/styles/20px/s3/2024-01/india_driving_car.jpg"
                      className="image-text-horizontal-image"
                      alt=""
                      height="258px"
                      width="360px"
                      data-lazyload="https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_horizontal/s3/2024-01/india_driving_car.jpg 360w, https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_horizontal_2x/s3/2024-01/india_driving_car.jpg 720w"
                      sizes="(min-width: 600px) 360px, 100vw"
                    />

                    <p className="image-with-copyright-info--text">© Farex</p>
                  </div>
                </figure>
              </div> */}

              <div className="farex-col-12 farex-col-12-md">
                <div className="farex-text image-text-horizontal-text">
                  <h2>
                    Our Farex drivers will get you there safely - day and night
                  </h2>
                  <p>
                    Our drivers will drop you off at your destination safely.
                    All of our drivers and hosts are fully trained and have
                    regular safety training, meaning they are always prepared
                    for any traffic and travel problems that may occur. The
                    drivers on these trips are also specially trained for
                    overnight operations. During the journey, safety will always be our and our
                    driver&apos;s main priority. Just sit back, relax, and enjoy
                    your trip!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="section-48989" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h3>Emergency numbers</h3>
            <table>
              <tbody>
                <tr>
                  <td>Emergency:</td>
                  <td>
                    <strong>112</strong>
                  </td>
                </tr>
                <tr>
                  <td>Women Helpline:</td>
                  <td>
                    <strong>1091</strong>
                  </td>
                </tr>
                <tr>
                  <td>Police:</td>
                  <td>
                    <strong>100</strong>
                  </td>
                </tr>
                <tr>
                  <td>Fire:</td>
                  <td>
                    <strong>101</strong>
                  </td>
                </tr>
                <tr>
                  <td>Ambulance:</td>
                  <td>
                    <strong>108</strong>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
          </div>
        </div>
      </div>
    </div>
  );
};
